import React, { useState } from 'react'
import { Body, Box, H4 } from '../layout'
import { DropDown } from './DropDown'

export const PriceTiers = ({ tiers }) => {
  const [selectedTier, setSelectedTier] = useState(0)
  const { price } = tiers[selectedTier]

  return (
    <Box fullWidth justifyContent="space-between" column gap={16}>
      <Box column gap={4}>
        {price
          ? <>
              <H4 align="left">
                ${price}&nbsp;
                <Body size={12} bold={false} style={{ marginLeft: -6 }} noWrap>p/a</Body>
              </H4>
              <Body size={12} lineHeight="normal">${Math.round(price / 12)} / month</Body>
            </>
          : <Body bold lineHeight={1}>Contact us</Body>
        }
      </Box>

      <Box column gap={8}>
        <Body bold noWrap lineHeight={1} size={16}>Number of teams</Body>
        <DropDown
          items={tiers.map(x => x.teams + ' teams')}
          value={selectedTier}
          onChange={setSelectedTier}
        />
      </Box>
    </Box>
  )
}